/**
 * Vue Router
 *
 * @library
 *
 * https://router.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue'
import Router from 'vue-router'
import { getActivePinia } from 'pinia'


// Routes
import paths from './paths'
import { guardRole } from './guardRole'

function route (path, view, name, meta) {
  return {
    name: name || view,
    path,
    meta: meta || {},
    component: (resovle) => import(`@/views/${view}.vue`).then(resovle)
  }
}

Vue.use(Router)

// Create a new router
const router = new Router({
  mode: 'history',
  base: process.env.VUE_APP_PATH,
  routes: paths.map(path => route(path.path, path.view, path.name, {requires_role: path.requires_role})),
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { selector: to.hash }
    }
    return { x: 0, y: 0 }
  }
})

// Navigation guard to check authentication state before each route
router.beforeEach((to, from, next) => {
  // Check if Pinia is available yet - if not, just proceed
  // This happens during initial app bootstrap
  if (!getActivePinia()) {
    next()
    return
  }

  // Lazy import to avoid circular dependency issues
  const { sessionStore } = require('@/store/pinia/sessionStore')
  const session = sessionStore()

  // If session is deauthenticating, wait for it to complete
  if (session.state === 'deauthenticating') {
    // Let the logout process complete, then navigate
    const unwatch = session.$subscribe((mutation, state) => {
      if (state.state === 'ready' || state.state === 'authenticated') {
        unwatch()
        guardRole(to, session, next)
      }
    })
    return
  }

  guardRole(to, session, next)
})

import Meta from 'vue-meta'

Vue.use(Meta,{
  keyName: 'metaInfo', // the component option name that vue-meta looks for meta info on.
      attribute: 'data-vue-meta', // the attribute name vue-meta adds to the tags it observes
      ssrAttribute: 'data-vue-meta-server-rendered', // the attribute name that lets vue-meta know that meta info has already been server-rendered
      tagIDKeyName: 'vmid' // the property name that vue-meta uses to determine whether to overwrite or append a tag
})

export default router
